// Cliente do assistente. Molde: painel.service.ts.
//
// Uma chamada, uma resposta — sem streaming nesta etapa. O `timeout` é longo de
// propósito: o assistente pode precisar de até cinco voltas de ferramenta antes
// de responder, e cada volta é uma ida ao modelo.
import api from "./api.service";

export interface MensagemDaConversa {
  papel: "user" | "assistant";
  texto: string;
}

export interface PassoDaFerramenta {
  nome: string;
  argumentos: Record<string, unknown>;
  ok: boolean;
}

export interface RespostaDoAgente {
  texto: string;
  /** O que ele consultou. A tela mostra, para a resposta ser conferível. */
  passos: PassoDaFerramenta[];
}

/** Nome técnico da ferramenta -> o que dizer para uma pessoa. */
const ROTULO_DA_FERRAMENTA: Record<string, string> = {
  resumo_da_rede: "panorama da rede",
  vendas: "relatório de vendas",
  caixa: "relatório de caixa",
  estoque: "relatório de estoque",
  compras_pendentes: "compras pendentes",
};

export function rotuloDaFerramenta(nome: string): string {
  return ROTULO_DA_FERRAMENTA[nome] ?? nome;
}

class AgenteClass {
  async conversar(mensagens: MensagemDaConversa[]): Promise<RespostaDoAgente> {
    const resposta = await api.post(
      "/agente/conversa",
      { mensagens },
      { timeout: 180000 },
    );
    return resposta.data;
  }
}

const agenteService = new AgenteClass();
export default agenteService;
